import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { renderToStaticMarkup } from 'react-dom/server';

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "./home.css";
import {
  QueryClient,
  QueryClientProvider,
  useMutation,
  useQuery,
  useQueryClient,
} from "react-query";

// import soru ile compenant soru sirasinin ayni olmasi onemli yoksa slayt bozuluyor
import Carousel from "../components/Carousel";

import { EffectFade, Navigation, Pagination, Keyboard } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";


const ProctoGlyvenol = () => {
  const [posts, setPosts] = useState([]);
  //const [postsh, setPostsh] = useState([]);
  const [sonuc10goster, setSonuc10] = useState([]);
  const [sonuc05goster, setSonuc05] = useState([]);
  const [sonuc03goster, setSonuc03] = useState([]);
  const [sonuc04goster, setSonuc04] = useState([]);
  const [sonuc25goster, setSonuc25] = useState([]);
  const [sonuc14goster, setSonuc14] = useState([]);
  const [sonuc20goster, setSonuc20] = useState([]);
  const [sonuc21goster, setSonuc21] = useState([]);
  const location = useLocation();
  const postId = location.pathname.split("/")[2];
  const records = posts.slice();
  //const recordsh = postsh.slice();
  const sonuc19 = 30;
  const sonuc24 = 30;
  const sonuc11 = 30;

  useEffect(() => {
  
  // sunum bilgileri
    const fetchData = async () => {
      //console.log("use effect home calisti");
      try {
        //console.log("postId", postId);
        const res = await axios.get(
          `https://api.recordatifocus.com/sunum-bilgileri/${postId}`
        );
        //console.log("res", res.data);
        setPosts(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
// sunum bilbileri
// 
// Soru 01
    const soruBir = async () => {
      const postId = location.pathname.split("/")[2];

      //console.log("postId", postId);
      const url = `https://api.recordatifocus.com/procto-glyvenol-01/${postId}`;
      const res = await fetch(url);
      const data = await res.json();
      let outputData = data.map((item) => {
        return {
          cevap: parseInt(item.cevap),
        };
      });
      //console.log(outputData);
      const result = Object.values(outputData).reduce(
        (r, { cevap }) => r + cevap,
        0
      );
      //console.log(result);
      const longeur = data.length;
      //console.log(longeur);
      //setPostsh(data);
      //console.log((result*100)/longeur);

      //let sonuc = 1;
      let sonuc = 100 - (result * 100) / longeur;
      console.log("Soru01 yanlis orani:", sonuc);

      if (sonuc >= sonuc19) {
      	const sonuc10goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/procto_glyvenol/Procto-Glyvenol_DocFocus_SUBAT26_Page_10.jpg"/></div>;
      	setSonuc10(sonuc10goster);
      } else {
      	const sonuc10goster = null;
      	setSonuc10(sonuc10goster);
      }
    };
  
    soruBir();

    
// soru 01
// 
// 
// 
// Soru 02
    const soruIki = async () => {
      const postId = location.pathname.split("/")[2];

      //console.log("postId", postId);
      const url = `https://api.recordatifocus.com/procto-glyvenol-02/${postId}`;
      const res = await fetch(url);
      const data = await res.json();
      let outputData = data.map((item) => {
        return {
          cevap: parseInt(item.cevap),
        };
      });
      //console.log(outputData);
      const result = Object.values(outputData).reduce(
        (r, { cevap }) => r + cevap,
        0
      );
      //console.log(result);
      const longeur = data.length;
      //console.log(longeur);
      //setPostsh(data);
      //console.log((result*100)/longeur);

      //let sonuc = 1;
      let sonuc = 100 - (result * 100) / longeur;
      console.log("Soru02 yanlis orani:", sonuc);

      if (sonuc >= sonuc19) {
      	const sonuc05goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/procto_glyvenol/Procto-Glyvenol_DocFocus_SUBAT26_Page_05.jpg"/></div>;
      	setSonuc05(sonuc05goster);
        //console.log(sonuc01goster);
      } else {
      	const sonuc05goster = null;
      	setSonuc05(sonuc05goster);
      }
    };
  
    soruIki();
// soru 02
// 
// 
// 
// Soru 03
    const soruUc = async () => {
      const postId = location.pathname.split("/")[2];

      //console.log("postId", postId);
      const url = `https://api.recordatifocus.com/procto-glyvenol-03/${postId}`;
      const res = await fetch(url);
      const data = await res.json();
      let outputData = data.map((item) => {
        return {
          cevap: parseInt(item.cevap),
        };
      });
      //console.log(outputData);
      const result = Object.values(outputData).reduce(
        (r, { cevap }) => r + cevap,
        0
      );
      //console.log(result);
      const longeur = data.length;
      //console.log(longeur);
      //setPostsh(data);
      //console.log((result*100)/longeur);

      //let sonuc = 1;
      let sonuc = 100 - (result * 100) / longeur;
      console.log("Soru03 yanlis orani:", sonuc);

      if (sonuc >= sonuc19) {
      	const sonuc03goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/procto_glyvenol/Procto-Glyvenol_DocFocus_SUBAT26_Page_03.jpg"/></div>;
      	const sonuc04goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/procto_glyvenol/Procto-Glyvenol_DocFocus_SUBAT26_Page_04.jpg"/></div>;
      	const sonuc25goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/procto_glyvenol/Procto-Glyvenol_DocFocus_SUBAT26_Page_25.jpg"/></div>;
      	setSonuc03(sonuc03goster);
      	setSonuc04(sonuc04goster);
      	setSonuc25(sonuc25goster);
        console.log(sonuc03goster);
      } else {
      	const sonuc03goster = null;
      	const sonuc04goster = null;
      	const sonuc25goster = null;
      	setSonuc03(sonuc03goster);
      	setSonuc04(sonuc04goster);
      	setSonuc25(sonuc25goster);
      }
    };
  
    soruUc();
// soru 03
// 
// 
// 
// 
// 
// 
// Soru 04
    const soruDort = async () => {
      const postId = location.pathname.split("/")[2];

      //console.log("postId", postId);
      const url = `https://api.recordatifocus.com/procto-glyvenol-04/${postId}`;
      const res = await fetch(url);
      const data = await res.json();
      let outputData = data.map((item) => {
        return {
          cevap: parseInt(item.cevap),
        };
      });
      //console.log(outputData);
      const result = Object.values(outputData).reduce(
        (r, { cevap }) => r + cevap,
        0
      );
      //console.log(result);
      const longeur = data.length;
      //console.log(longeur);
      //setPostsh(data);
      //console.log((result*100)/longeur);

      //let sonuc = 1;
      let sonuc = 100 - (result * 100) / longeur;
      console.log("Soru04 yanlis orani:", sonuc);

      if (sonuc >= sonuc24) {
      	const sonuc14goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/procto_glyvenol/Procto-Glyvenol_DocFocus_SUBAT26_Page_14.jpg"/></div>;
      	setSonuc14(sonuc14goster);
        //console.log(sonuc01goster);
      } else {
      	const sonuc14goster = null;
      	setSonuc14(sonuc14goster);
      }
    };
  
    soruDort();
// soru 04
// 
// 
// 
// Soru 05
    const soruBes = async () => {
      const postId = location.pathname.split("/")[2];

      //console.log("postId", postId);
      const url = `https://api.recordatifocus.com/procto-glyvenol-05/${postId}`;
      const res = await fetch(url);
      const data = await res.json();
      let outputData = data.map((item) => {
        return {
          cevap: parseInt(item.cevap),
        };
      });
      //console.log(outputData);
      const result = Object.values(outputData).reduce(
        (r, { cevap }) => r + cevap,
        0
      );
      //console.log(result);
      const longeur = data.length;
      //console.log(longeur);
      //setPostsh(data);
      //console.log((result*100)/longeur);

      //let sonuc = 1;
      let sonuc = 100 - (result * 100) / longeur;
      console.log("Soru05 yanlis orani:", sonuc);

      if (sonuc >= sonuc24) {
      	const sonuc20goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/procto_glyvenol/Procto-Glyvenol_DocFocus_SUBAT26_Page_20.jpg"/></div>;
      	const sonuc21goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/procto_glyvenol/Procto-Glyvenol_DocFocus_SUBAT26_Page_21.jpg"/></div>;
      	setSonuc20(sonuc20goster);
      	setSonuc21(sonuc21goster);
        //console.log(sonuc01goster);
      } else {
      	const sonuc20goster = null;
      	const sonuc21goster = null;
      	setSonuc20(sonuc20goster);
      	setSonuc21(sonuc21goster);
      }
    };
  
    soruBes();
// soru 05
// 
// 
// 
// Soru 06
// soru 06
// 
// 
// 
// Soru 07
// soru 07
// 
// 
// 
// Soru 08
// soru 081
// 
// 
// 
// Soru 082
// soru 082
// 
// 
// 
// Soru 
// 
// 

  
  
  }, [postId]);


const slide01goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/procto_glyvenol/Procto-Glyvenol_DocFocus_SUBAT26_Page_01.jpg"/></div>;
const slide02goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/procto_glyvenol/Procto-Glyvenol_DocFocus_SUBAT26_Page_02.jpg"/></div>;
const slide03goster = sonuc03goster;
const slide04goster = sonuc04goster;
const slide05goster = sonuc05goster;
const slide06goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/procto_glyvenol/Procto-Glyvenol_DocFocus_SUBAT26_Page_06.jpg"/></div>;
const slide07goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/procto_glyvenol/Procto-Glyvenol_DocFocus_SUBAT26_Page_07.jpg"/></div>;
const slide08goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/procto_glyvenol/Procto-Glyvenol_DocFocus_SUBAT26_Page_08.jpg"/></div>;
const slide09goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/procto_glyvenol/Procto-Glyvenol_DocFocus_SUBAT26_Page_09.jpg"/></div>;
const slide10goster = sonuc10goster;
const slide11goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/procto_glyvenol/Procto-Glyvenol_DocFocus_SUBAT26_Page_11.jpg"/></div>;
const slide12goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/procto_glyvenol/Procto-Glyvenol_DocFocus_SUBAT26_Page_12.jpg"/></div>;
const slide13goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/procto_glyvenol/Procto-Glyvenol_DocFocus_SUBAT26_Page_13.jpg"/></div>;
const slide14goster = sonuc14goster;
const slide15goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/procto_glyvenol/Procto-Glyvenol_DocFocus_SUBAT26_Page_15.jpg"/></div>;
const slide16goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/procto_glyvenol/Procto-Glyvenol_DocFocus_SUBAT26_Page_16.jpg"/></div>;
const slide17goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/procto_glyvenol/Procto-Glyvenol_DocFocus_SUBAT26_Page_17.jpg"/></div>;
const slide18goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/procto_glyvenol/Procto-Glyvenol_DocFocus_SUBAT26_Page_18.jpg"/></div>;
const slide19goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/procto_glyvenol/Procto-Glyvenol_DocFocus_SUBAT26_Page_19.jpg"/></div>;
const slide20goster = sonuc20goster;
const slide21goster = sonuc21goster;
const slide22goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/procto_glyvenol/Procto-Glyvenol_DocFocus_SUBAT26_Page_22.jpg"/></div>;
const slide23goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/procto_glyvenol/Procto-Glyvenol_DocFocus_SUBAT26_Page_23.jpg"/></div>;
const slide24goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/procto_glyvenol/Procto-Glyvenol_DocFocus_SUBAT26_Page_24.jpg"/></div>;
const slide25goster = sonuc25goster;
const slide26goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/procto_glyvenol/Procto-Glyvenol_DocFocus_SUBAT26_Page_26.jpg"/></div>;
const slide27goster = <div><img className="img-fluid" src="https://slide.recordatifocus.com/upload/procto_glyvenol/Procto-Glyvenol_DocFocus_SUBAT26_Page_27.jpg"/></div>;

const slides = [slide01goster, slide02goster, slide03goster, slide04goster, slide05goster, slide06goster, slide07goster, slide08goster, slide09goster, slide10goster, slide11goster, slide12goster, slide13goster, slide14goster, slide15goster, slide16goster, slide17goster, slide18goster, slide19goster, slide20goster, slide21goster, slide22goster, slide23goster, slide24goster, slide25goster, slide26goster, slide27goster];
var filtered = slides.filter(Boolean);
const listItems = filtered.map((number) =>  <SwiperSlide>{number}</SwiperSlide>);

  return (
    <>
      <Swiper
        effect={"fade"}
        pagination={{
          type: "fraction",
        }}
        keyboard={{
          enabled: true,
        }}
        navigation={true}
        modules={[EffectFade, Navigation, Pagination, Keyboard]}
        className="mySwiper"
      >
        {listItems}
      </Swiper>
  
      {records.map((post) => (
        <div className="container d-none my-4" key={post.id}>
          <div className="sunum-adi">Sunum Adi: {post.title}</div>
  		  <div className="sunum-adi">Sunum Tarihi: {post.tarih}</div>
  		  <div className="sunum-adi">Sunan Kisi: {post.uid}</div>
        </div>
      ))}

<div className={`col d-flex flex-column align-items-center justify-content-center pb-5 footer-${location.pathname.split("/")[2]}`}>

<div className="card mx-2" style={{width: "8rem"}}>
  <a href="https://qr.recordatifocus.com/hippurinkub" className="text-decoration-none text-black" target="_blank">
  <img alt="" src="https://www.recordatifocus.com/images/procto-glyvenol-kub.png" className="img-fluid" /></a>
  <div className="p-1" style={{backgroundColor: "#f09d8e"}}>
    <a href="https://qr.recordatifocus.com/roctoub" className="text-decoration-none text-white" target="_blank">
    	<div className="text-center small fw-bold">Procto-Glyvenol</div>
  	</a>
  </div>
</div>
<p class="pb-5 mx-3 fw-bold footer-link-undefined">www.recordati.com.tr</p>
</div>

  
    </>
  );
};

export default ProctoGlyvenol;
